import { post } from "utils/apiClient";

import React, { createContext, useState } from 'react'


const LocationMapImportContext = createContext()

function Provider({ children }) {
    const api_url = process.env.REACT_APP_API_URL

    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [importResponse, setImportResponse] = useState()


    const submitImport = async (data) => {
        setLoading(true)
        let response = null
        try {
            const url = 'email/location/map/import',
            response = await post(url, data)
            console.log(response)
            setImportResponse(response)
            setLoading(false)
            setSuccess(true)
        } catch (error) {
            console.error(error)
            setLoading(false)
            setError(true)
        }
    }

    const valueToShare = {
        loading,
        setLoading,
        success,
        setSuccess,
        error,
        setError,
        submitImport,
        importResponse
    }

    return (
        <LocationMapImportContext.Provider value={valueToShare}>{children}</LocationMapImportContext.Provider>
    )

}


export { Provider }
export default LocationMapImportContext